import React , {useEffect, useState, useRef} from 'react'
import { motion } from 'framer-motion'
import {MdOutlineClose} from "react-icons/md";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/splide/dist/css/splide.min.css";
import { db} from "../configs/firebaseconfig";
import { doc, getDoc } from "firebase/firestore";
import { BsFillPatchPlusFill } from 'react-icons/bs';
export default function RecipeDetail({id,type, close}) {
    const [recipe, setrecipe]= useState({})
    async function getRecipeInfo(){
     
      let data= []
      setrecipe(data);
      if(type==="myRecip") {
        try {
          const docRef = doc(db, "recipes", id);
          const docSnap = await getDoc(docRef);
          data=docSnap.data()
        } catch (err){
         
        }
       
      } else {
        const url= `https://api.spoonacular.com/recipes/${id}/information?apiKey=${process.env.REACT_APP_SPOONACULAER_API}`
        const api= await fetch(url)
         data = await api.json() 
      }
        
         setrecipe(data)
        //  setExpRecips(res.results)
        // 
        
       }
       useEffect(() => {
         getRecipeInfo()
       }, [id])
       const infoThumbnails = useRef()
       let current
       const infoSplideCont = useRef()
     
     function move(e){
       try {
         let list =  [...infoThumbnails.current.children]
         let thumbnail=list[e.index]
         if(thumbnail) {
             if(current){
                 current.classList.remove("active")
             }
             thumbnail.classList.add('active')
             current=thumbnail
         }
         //
        // alert('jhjnn')
       } catch {
        
       }
       
     }
if (id === "") return null
  return (
    <>
    
    <div className="overlay" onClick={close} />
 
    <motion.div
    initial={{ y: '-100vh', x:'-50%' }}
    animate={{ y: '-50%',  x:'-50%'}}
    transition={{ delay: 0.2}}
     className='popup  recipe-detail'>
        
        <div className="content scrollY">
           
            <motion.h1>{recipe.title}</motion.h1>
            <div className="btns center" ref={infoThumbnails}>
                {type!=="myRecip" &&<div className="btn thumbnail"  onClick={()=> {infoSplideCont.current.go(0)}}>Summery</div>}
                <div className="btn thumbnail"  onClick={()=> {infoSplideCont.current.go(type!=="myRecip"? 1:0)}}>Instruction</div>
                <div className="btn thumbnail"  onClick={()=> {infoSplideCont.current.go(type!=="myRecip"? 2:1)}}>Ingredients</div>
            </div>
           
            <Splide
                ref={infoSplideCont}
                onMove={move}
                onMoved={move}
                onDrag={move}
                id="splide"
                className="splide"
                options={{
                arrows: false,
                pagination: false,
                drag: "free",
                }}
                >
                    {type!=="myRecip" &&<SplideSlide >
                    <div dangerouslySetInnerHTML={{__html:recipe.summary}} ></div>
                    </SplideSlide>}
                    <SplideSlide >
                    <div dangerouslySetInnerHTML={{__html:recipe.instructions}} ></div>
                      
                    </SplideSlide>
                    <SplideSlide >
                        {recipe.extendedIngredients && recipe.extendedIngredients.map((item, index)=>(
                          <div className="f-start ingredients" key={index}>
                            {type!=="myRecip"?(<><div className="s-img center">
                            <img src={`https://spoonacular.com/cdn/ingredients_100x100/${item.image}`} alt="" />
                            </div>
                            <p>{item.original}</p></>):
                            (<>
                              <BsFillPatchPlusFill/>
                              <p>{item}</p>
                            </>
                            )}
                          </div>
                        ))}
                    </SplideSlide>
                </Splide>
            
        </div>
        <motion.img 
          initial={{ x: '100vw' }}
          animate={{ x: 0 }}
        transition={{ delay: 0.2}} src={recipe.image} alt="recipe" />
        <div className="close-btn center" onClick={close}><MdOutlineClose /></div>
    </motion.div>
    
    
    </>
  )
}
